import type { MergeHead, UseHeadInput } from '@unhead/vue'

export const createStructuredData = (gtmId?: string): UseHeadInput<MergeHead> => {
  const origin = 'https://www.bistroo.nl'
  const image = `${origin}/images/business-portal/bistroo-zakelijk-og-image.jpg`

  const scripts: Array<Record<string, unknown>> = []

  const organization = {
    '@type': 'Organization',
    '@id': '#org',
    name: 'Bistroo',
    url: origin,
    logo: { '@type': 'ImageObject', url: image },
    sameAs: ['https://nl.linkedin.com/company/bistroo-nl', 'https://www.instagram.com/bistroo.nl/'],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        url: `${origin}/info/support`,
        telephone: '+31850250205',
        email: 'info@bistroo.nl',
        availableLanguage: ['nl'],
      },
      {
        '@type': 'ContactPoint',
        contactType: 'sales',
        url: `${origin}/producten/webshop`,
        telephone: '+31850250205',
        email: 'info@bistroo.nl',
        availableLanguage: ['nl'],
      },
    ],
  }

  const website = {
    '@type': 'WebSite',
    url: origin,
    name: 'Bistroo',
    inLanguage: 'nl-NL',
    publisher: { '@id': '#org' },
  }

  const webpage = {
    '@type': 'WebPage',
    '@id': `${origin}/#webpage`,
    name: 'We simply serve restaurants',
    description: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.',
    url: `${origin}/`,
    inLanguage: 'nl-NL',
    isPartOf: { '@type': 'WebSite', url: origin },
    primaryImageOfPage: { '@type': 'ImageObject', url: image },
  }

  const siteNav = [
    {
      '@type': 'SiteNavigationElement',
      name: 'Bistroo Webshop',
      url: `${origin}/producten/webshop`,
    },
    { '@type': 'SiteNavigationElement', name: 'Bistroo Page', url: `${origin}/producten/website` },
    { '@type': 'SiteNavigationElement', name: 'Bistroo QR', url: `${origin}/producten/qr` },
    { '@type': 'SiteNavigationElement', name: 'Bistroo Device', url: `${origin}/producten/posdevice` },
    {
      '@type': 'SiteNavigationElement',
      name: 'Bistroo Manager',
      url: `${origin}/producten/manager`,
    },
    { '@type': 'SiteNavigationElement', name: 'Bistroo Kiosk', url: `${origin}/producten/kiosk` },
    { '@type': 'SiteNavigationElement', name: 'Bistroo POS', url: `${origin}/producten/pos` },
    { '@type': 'SiteNavigationElement', name: 'Prijzen', url: `${origin}/prijzen` },
    { '@type': 'SiteNavigationElement', name: 'Integraties', url: `${origin}/integraties` },
    { '@type': 'SiteNavigationElement', name: 'Support', url: `${origin}/info/support` },
    { '@type': 'SiteNavigationElement', name: 'FAQ', url: `${origin}/info/faq` },
  ]

  const graph = {
    '@context': 'https://schema.org',
    '@graph': [organization, website, webpage, ...siteNav],
  }

  /** Head **/
  if (gtmId) {
    const gtm = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`
    scripts.push({ children: gtm })
  }
  scripts.push({ type: 'application/ld+json', children: JSON.stringify(graph, null, 2) })

  return {
    title: 'Bistroo - We simply serve restaurants',
    meta: [
      {
        name: 'description',
        content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.',
      },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
      { name: 'charset', content: 'UTF-8' },

      { property: 'og:title', content: 'We simply serve restaurants' },
      {
        property: 'og:description',
        content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.',
      },
      { property: 'og:image', content: image },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: origin },
      { property: 'og:site_name', content: 'Bistroo' },

      { name: 'twitter:title', content: 'We simply serve restaurants' },
      {
        name: 'twitter:description',
        content: 'Bespaar tijd en verhoog je winst, met online bestellingen via Bistroo.',
      },
    ],
    link: [
      { rel: 'icon', href: '/favicon.ico' },
    ],
    script: scripts,
  }
}
